import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Linkedin, Instagram, Facebook } from 'lucide-react';
import CTABanner from '../components/landingPage/CTABanner';
import SocialMediaCTA from '../components/SocialMediaCTA';
import NewsSection from '../components/landingPage/NewsSection';

const NewsDetailPage = () => {
  const [newsEvent, setNewsEvent] = useState(null);
  const [error, setError] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const fetchNewsEvent = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/news-events/${id}`);
        if (response.ok) {
          const data = await response.json();
          setNewsEvent(data);
        } else {
          const data = await response.json();
          setError(data.message || 'Failed to fetch news event');
        }
      } catch (error) {
        setError('Error fetching news event');
      }
    };

    fetchNewsEvent();
  }, [id]);

  useEffect(() => {
    if (newsEvent) {
      console.log('News Event Data (Stringified):', JSON.stringify(newsEvent, null, 2));
    }
  }, [newsEvent]);

  if (error) {
    return <div className="text-red-500 text-center my-10">{error}</div>;
  }

  if (!newsEvent) {
    return <div className="text-center my-10">Loading...</div>;
  }

  const headerImageUrl = newsEvent.images && newsEvent.images.length > 0 ? `http://localhost:5000${newsEvent.images[0].imageUrl}` : '';

  return (
    <div className="rk-page">
      <style>
        {`
          .prose ul {
            list-style-type: disc;
            margin-left: 20px;
          }
          .prose ol {
            list-style-type: decimal;
            margin-left: 20px;
          }
        `}
      </style>
      <section className="relative h-[40vh] sm:h-[50vh] md:h-[60vh] lg:h-[64vh]">
        {headerImageUrl && (
          <img src={headerImageUrl} alt={newsEvent.title} className="absolute top-0 left-0 w-full h-full object-cover" />
        )}
        <div className="absolute top-0 left-0 w-full h-full bg-black/70 flex items-center justify-center">
          <h1 className=" text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-center drop-shadow-lg font-poppins mx-auto w-11/12 md:w-3/4 lg:w-2/3">
            {newsEvent.category.name}
          </h1>
        </div>
        <div className="absolute left-4 top-1/2 -translate-y-1/2 flex flex-col space-y-4 ">
          <a href="#" className="text-accent-yellow hover:text-white transition-colors duration-300">
            <Linkedin size={28} />
          </a>
          <a href="#" className="text-accent-yellow hover:text-white transition-colors duration-300">
            <Instagram size={28} />
          </a>
          <a href="#" className="text-accent-yellow hover:text-white transition-colors duration-300">
            <Facebook size={28} />
          </a>
        </div>
      </section>

      <section className="relative z-10 -mt-16 sm:-mt-20 mx-auto w-11/12 md:w-3/4 lg:w-2/3 bg-white p-6 sm:p-8 md:p-12 shadow-lg rounded-lg">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-[#364A9A] font-poppins">
          {newsEvent.title}
        </h2>
        <div className="text-gray-500 text-xs sm:text-sm mb-3 sm:mb-4">{new Date(newsEvent.publishedDate).toLocaleDateString()}</div>
        <div className="prose max-w-none text-sm sm:text-base" dangerouslySetInnerHTML={{ __html: newsEvent.content }}></div>
        {newsEvent.images && newsEvent.images.length > 1 && (
          <div className="mt-6 sm:mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            {newsEvent.images.slice(1).map(image => (
              <img key={image.id} src={`http://localhost:5000${image.imageUrl}`} alt={newsEvent.title} className="w-full h-48 sm:h-56 md:h-64 object-cover rounded-lg shadow-lg" />
            ))}
          </div>
        )}
      </section>

      <CTABanner className="my-8 sm:my-12" />
      <SocialMediaCTA className="my-8 sm:my-12" />
      <NewsSection className="my-8 sm:my-12" />
    </div>
  );
};

export default NewsDetailPage;
